export default "__VITE_ASSET__BFBU6h_q__"